import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';


export const postSellerReq = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/create-req`,data);
        return response.data.data;
    } catch (error) {
        console.log("postSellerReq - error", error)
        return handleApiError(error)
    }
}

export const updateSellerReq = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/update`,data);
        return response.data.data;
    } catch (error) {
        console.log("updateSellerReq - error", error)
        return handleApiError(error)
    }
}

export const postMail = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/send-quotation-mail`,data);
        return response.data.data;
    } catch (error) {
        console.log("postMail - error", error)
        return handleApiError(error)
    }
}

export const postBulkSellerReq = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/bulk-req`,data)
        console.log('send mail res', response)
        return response.data.data
    } catch (error) {
        console.log("postBulkSellerReq - error", error)
        return handleApiError(error)
    }
}

export const getSellerReqByBuyerReqId = async (buyerReqId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-req/${buyerReqId}`);
        return response.data.data;
    } catch (error) {
        console.log("getSellerReqByBuyerReqId - error", error)
        return handleApiError(error)
    }
}


export const getSellersByUserIds = async (data) => {
    try {

        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/userIds`, data);
        return response.data.data;
    } catch (error) {
        console.log("getSellersByUserIds - error", error)
    }
}



export const getSellersByUserIdsForUseFromStock = async (data) => {
    try {

        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/useStockUserIds`, data);
        return response.data.data;
    } catch (error) {
        console.log("getSellersByUserIdsForUseFromStock - error", error)
    }
}


export const getSellerDetailsBybuyerReqIdForBuyerQuote = async (buyerReqId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/sellers/${buyerReqId}`);
        // console.log("getSellerDetailsBybuyerReqIdForBuyerQuote resp", response)
        return response.data.data;
    } catch (error) {
        console.log("getSellerReqByBuyerReqId - error", error)
        return handleApiError(error)
    }
}

export const expireSellerReqItem = async (sellerReqItemId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/update/${sellerReqItemId}`);
        return response.data.data;
    } catch (error) {
        console.log("expireSellerReqItem - error", error)
        return handleApiError(error)
    }
}

export const getShippingAddress = async (companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-req/company-addr/${companyId}`);
        return response.data.data;
    } catch (error) {
        console.log("getShippingAddress - error", error)
        return handleApiError(error)
    }
}

export const getSellerReqsByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/all-seller-req`, data);
        return response.data;
    } catch (error) {
        console.log("getSellerReqsByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const sendQuotationMailToVendor = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/send-mail`, data);
        return response.data;
    } catch (error) {
        console.log("sendQuotationMailToVendor - error", error)
        return handleApiError(error)
    }
}


export const getMaterialsInStock = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/materialId`, data);
        return response.data;
    } catch (error) {
        console.log("getSellerReqsByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const getSellerDetailsBySellerReqs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/seller-details`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerDetailsBySellerReqs - error", error)
        return handleApiError(error)
    }
}

export const getSellerSuggestions = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/seller-suggestions`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerDetailsBySellerReqs - error", error)
        return handleApiError(error)
    }
}

export const getHSNSuggestions = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/hsn-suggestions`, data);
        return response.data;
    } catch (error) {
        console.log("getHSNSuggestions - error", error)
        return handleApiError(error)
    }
}

export const insertUseFromStockSellerReq = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-req/useFromStockSellerReq`,data);
        console.log("repsoe", response)
        return response.data.data;
    } catch (error) {
        console.log("insertUseFromStockSellerReq - error", error)
        return handleApiError(error)
    }
}

export const getSellerReqBySellerReqId = async (sellerReqId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-req/get-seller-req/${sellerReqId}`);
        return response.data.data;
    } catch (error) {
        console.log("getSellerReqBySellerReqId - error", error)
        return handleApiError(error)
    }
}
